/**
 * @generated SignedSource<<4a65eadb844da1ec82523838ecafac55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateLinkedEventInput = {
  clientMutationId?: string | null;
  guid: string;
  streamId: string;
};
export type LinkEventModalMutation$variables = {
  input: UpdateLinkedEventInput;
};
export type LinkEventModalMutation$data = {
  readonly updateLinkedEvent: {
    readonly stream: {
      readonly claimedEvents: ReadonlyArray<{
        readonly attendees: ReadonlyArray<{
          readonly email: string;
        } | null>;
      }>;
      readonly id: string;
      readonly linkedEvent: {
        readonly finalOccurrence: string | null;
        readonly guid: string;
        readonly id: string;
        readonly nextOccurrence: {
          readonly end: string | null;
          readonly start: string | null;
        } | null;
        readonly recurrenceRule: ReadonlyArray<string | null> | null;
        readonly title: string;
      } | null;
      readonly linkedEventGuid: string | null;
    };
  } | null;
};
export type LinkEventModalMutation = {
  response: LinkEventModalMutation$data;
  variables: LinkEventModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkedEventGuid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurrenceRule",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalOccurrence",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Attendee",
  "kind": "LinkedField",
  "name": "attendees",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkEventModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateLinkedEventPayload",
        "kind": "LinkedField",
        "name": "updateLinkedEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "linkedEvent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "nextOccurrence",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "claimedEvents",
                "plural": true,
                "selections": [
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinkEventModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateLinkedEventPayload",
        "kind": "LinkedField",
        "name": "updateLinkedEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "linkedEvent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "nextOccurrence",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "claimedEvents",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1a2870bc90c76b76cf5d70d99f67683e",
    "id": null,
    "metadata": {},
    "name": "LinkEventModalMutation",
    "operationKind": "mutation",
    "text": "mutation LinkEventModalMutation(\n  $input: UpdateLinkedEventInput!\n) {\n  updateLinkedEvent(input: $input) {\n    stream {\n      id\n      linkedEventGuid\n      linkedEvent {\n        id\n        guid\n        title\n        recurrenceRule\n        nextOccurrence {\n          start\n          end\n          id\n        }\n        finalOccurrence\n      }\n      claimedEvents {\n        attendees {\n          email\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b99cb79217d88b72f36fd58e87e9218b";

export default node;
